import { createFileRoute, Link } from "../lib/router-compat";
import { PageShell, PanImage } from "../components/PageShell";

export const Route = createFileRoute("/maine-pan-production")({
  head: () => ({
    meta: [
      { title: "Maine Pan Productions — Steel Pan Makers & Tuners" },
      { name: "description", content: "Steel pan makers and tuners in Brooksville, Maine since 1974." },
    ],
  }),
  component: MainePanPage,
});

const PANS = [
  "D Tenors",
  "C Tenors",
  "Double Tenors",
  "Double Seconds",
  "Guitars",
  "Cellos",
  "Tenor Bass",
  "Six Bass",
];

const PEOPLE = [
  { role: "Owner, Maker and Tuner", name: "Nigel P. Chase" },
  { role: "Founder", name: "Carl Chase" },
  { role: "Master Tuner / Mentor", name: "Roland Harrigan" },
];

function MainePanPage() {
  return (
    <PageShell
      panBackdrop={true}
      tag="Brooksville, Maine · Since 1974"
      title={<>Maine Pan <span className="text-primary">Productions</span>.</>}
      intro="Steel pan makers and tuners. Founded by Carl Chase in 1974 and carried on by Nigel Chase, with master tuner Roland Harrigan returning from Trinidad to support Maine Pan Productions in Brooksville."
    >
      {/* Editorial hero — split, no card chrome */}
      <section className="border-y border-border/40 py-10 md:py-14">
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7 -mx-5 md:mx-0">
            <PanImage
              id="unnamed-2.jpg"
              alt="Maine Pan Productions"
              className="w-full h-[320px] md:h-[440px] object-cover grayscale-[15%]"
              width={1400}
            />
          </div>
          <div className="md:col-span-5">
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary">Everything for steelbands</div>
            <h2 className="mt-5 font-display italic text-3xl md:text-5xl leading-[1.02]">
              Contact Nigel<br/>for prices.
            </h2>
            <div className="mt-8 flex flex-col gap-4">
              <a
                href="mailto:nigelchase@gmail.com"
                className="group inline-flex items-center gap-4 text-[11px] tracking-[0.35em] uppercase text-primary hover:text-primary/70 transition"
              >
                <span className="h-px w-10 bg-primary group-hover:w-16 transition-all" />
                nigelchase@gmail.com
              </a>
              <Link
                to="/contact"
                className="group inline-flex items-center gap-4 text-[11px] tracking-[0.35em] uppercase text-foreground/60 hover:text-foreground transition"
              >
                <span className="h-px w-10 bg-foreground/40 group-hover:w-16 transition-all" />
                Send a message
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* People + Catalog — two-column editorial */}
      <div className="mt-16 grid md:grid-cols-12 gap-12">
        {/* People */}
        <div className="md:col-span-5">
          <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">The makers</div>
          <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Hands behind the steel</h2>
          <div className="mt-6 border-t border-border/40">
            {PEOPLE.map((p) => (
              <div key={p.name} className="py-4 border-b border-border/40">
                <div className="font-display italic text-xl md:text-2xl">{p.name}</div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.3em] text-foreground/55">{p.role}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Catalog */}
        <div className="md:col-span-7">
          <div className="flex items-end justify-between gap-4">
            <div>
              <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">The catalog</div>
              <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Everything for steelbands</h2>
            </div>
            <div className="text-[10px] uppercase tracking-[0.4em] text-foreground/40 whitespace-nowrap">
              {PANS.length} voices
            </div>
          </div>
          <ul className="mt-6 grid grid-cols-2 border-t border-border/40">
            {PANS.map((name) => (
              <li key={name} className="py-3 px-1 border-b border-border/40 font-display italic text-lg md:text-xl hover:text-primary transition">
                {name}
              </li>
            ))}
          </ul>
          <p className="mt-5 text-[13px] text-foreground/65 leading-relaxed">
            Used pans available for rent and for sale · Stands and sticks for all ·{" "}
            <a href="mailto:nigelchase@gmail.com" className="text-primary hover:text-primary/70">
              Contact Nigel for prices
            </a>
          </p>
        </div>
      </div>
    </PageShell>
  );
}
